module.exports = __webpack_public_path__ + "static/media/with-probate.f36a7727.svg";